import { render, staticRenderFns } from "./ChatFavoritos.vue?vue&type=template&id=0f716018&scoped=true"
import script from "./ChatFavoritos.vue?vue&type=script&lang=js"
export * from "./ChatFavoritos.vue?vue&type=script&lang=js"
import style0 from "./ChatFavoritos.vue?vue&type=style&index=0&id=0f716018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f716018",
  null
  
)

export default component.exports